<div class="card l-bg-red-dark mb-3">
    <div class="card-statistic-3 p-4">
        <div class="card-icon card-icon-large">
            <em class="fas fa-user-times"></em>
        </div>
        <div class="mb-4">
            <h5 class="card-title mb-0">Excluir clientes</h5>
        </div>
        <div class="row align-items-center mb-2 d-flex">
            <div class="col-8">
                <h2 class="d-flex align-items-center mb-0">
                    {{ count }}
                </h2>
            </div>
        </div>
        <div class="link-to pr-5">
            <a href="javascript:void(0)" [routerLink]="['/pages/remove-customers']">
                <span>Visualizar clientes</span>
            </a>
        </div>
    </div>
</div>
